import { IPDefaultButton, IPPrimaryButton, IPSeparator, IPSpinButton, IPText } from 'baseComponents';
import { IPCallout } from 'baseComponents/Callout/IPCallout';
import { IPDirectionalHint } from 'baseComponents/Dialog/IPDialog';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall, globalTextStylesError } from 'globalStyles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'utils/string';

interface IEditNumberFieldCallOut {
  targetId: string;
  onClose: () => void;
  onUpdate: (newText: number) => string | undefined;
  isVisible: boolean;
  value?: number;
  isBusy?: boolean;
  max?: number;
  min?: number;
  height?: number;
  width?: number;
  maxHeight?: number;
  required?: boolean;
  readOnly?: boolean;
}

const EditNumberFieldCallOut = (props: IEditNumberFieldCallOut) => {
  const [newValue, setNewValue] = useState<number>(0);
  const [error, setError] = useState<string | undefined>(undefined);
  const { t } = useTranslation(['translation']);
  const maxIntVal = 999999999;

  useEffect(() => {
    setNewValue(props.value || 0);
    setError(undefined);
  }, [props.value]);

  return (
    <IPCallout
      hidden={!props.isVisible}
      styles={{
        root: {
          padding: '10px 12px',
        },
      }}
      setInitialFocus
      target={`#${props.targetId}`}
      directionalHint={IPDirectionalHint.bottomLeftEdge}
      onDismiss={props.onClose}
      beakWidth={16}
    >
      <IPStack tokens={globalStackTokensGapSmall}>
        <IPStack.Item>
          <IPSpinButton
            value={newValue.toString()}
            min={Math.max(props.min ?? -maxIntVal, -maxIntVal)}
            max={Math.min(props.max ?? maxIntVal, maxIntVal)}
            onChange={(ev, value) => {
              if (value === undefined || !value) {
                setNewValue(0);
              } else {
                const numVal = Number.parseInt(value);
                setNewValue(numVal);
                const err = props.onUpdate(numVal);
                setError(err);
              }
            }}
            styles={{ root: { width: 50 } }}
          />
          {error && (
            <IPText variant="small" styles={globalTextStylesError}>
              {error}
            </IPText>
          )}
        </IPStack.Item>
        <IPSeparator />
        <IPStack.Item>
          <IPStack horizontal tokens={globalStackTokensGapSmall} horizontalAlign="end">
            <IPStack.Item>
              <IPPrimaryButton
                onClick={() => {
                  props.onUpdate(newValue);
                  props.onClose();
                }}
                disabled={
                  !isEmpty(error) || props.isBusy || props.readOnly || (props.required === true && newValue === 0)
                }
              >
                {t('translation:General.Button.Save')}
              </IPPrimaryButton>
            </IPStack.Item>
            <IPStack.Item>
              <IPDefaultButton
                onClick={() => {
                  props.onClose();
                }}
              >
                {t('translation:General.Button.Cancel')}
              </IPDefaultButton>
            </IPStack.Item>
          </IPStack>
        </IPStack.Item>
      </IPStack>
    </IPCallout>
  );
};

export default EditNumberFieldCallOut;
